<template>
    <div>
        <p v-if="rates == null"><i class="far fa-circle-notch fa-spin"></i></p>
        <div v-if="rates">
            <p><strong>Valeur :</strong> {{ currency(rates.valuation.accepted) }} acceptés sur {{ currency(rates.valuation.total) }} au total / {{ rates.valuation.percent }}%</p>
            <p><strong>Quantité :</strong> {{ rates.quantity.accepted }} acceptés sur {{ rates.quantity.total }} au total / {{ rates.quantity.percent }}%</p>
        </div>
    </div>
</template>

<script>
    export default {
        props : {
            route : String,
            from: String,
            to: String
        },
        data() {
            return {
                rates : null
            };
        },
        methods : {
            getData : async function(){
                fetch(this.route + '?from=' + this.from + '&to' + this.to, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.rates = data
                }).catch(error => {
                    console.log(error)
                });
            },
        },
        async mounted() {
            await this.getData();
        }
    }
</script>
